<template>
  <!-- viewer product list --->
  <div
    class="whatconttentbox modal fade"
    :style="whatsNewmodelOpen ? 'display:block;' : 'display:none;'"
    tabindex="-1"
    role="dialog"
    aria-labelledby="myModalLabel"
  >
    <div class="modal-dialog modal-dialog-center" role="document">
      <div class="modal-content">
        <button type="button" class="close" @click.prevent="whatsClosemodel()">
          <span aria-hidden="true">&times;</span>
        </button>
        <h2>{{ $t('whatsnew') }}</h2>

        <ul>
          <li>
            <h3 class="title">{{ $t('questionTitle') }}</h3>
            <p>
              {{ $t('questionDesc') }}
            </p>
          </li>
          <li>
            <h3 class="title">{{ $t('ShoppingTitle') }}</h3>
            <p>
              {{ $t('shoppingDesc') }}
            </p>
          </li>
          <li>
            <h3 class="title">{{ $t('heartTitle') }}</h3>
            <p>
              {{ $t('heartDesc') }}
            </p>
          </li>
          <li>
            <h3 class="title">{{ $t('callingTitle') }}</h3>
            <p>
              {{ $t('callingDesc') }}
            </p>
          </li>
        </ul>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'WhatsNew',
  props: ['room_id', 'whatsNewmodelOpen', 'channel'],
  data() {
    return {
      viewerProductList: null
    }
  },
  methods: {
    whatsClosemodel() {
      $('.whatconttentbox').modal('hide')
      //   this.whatsNewmodelOpen = false
    }
  },
  sockets: {}
}
</script>
